'use client'

/** 1.67 — a waiter whose row the owner switched off sees this and nothing else (fail closed, Codex #6). */
import { UserX } from 'lucide-react'
import { createClient } from '@/lib/supabase/client'
import { signOutThisDevice } from '@/lib/sign-out'
import { useStore } from '@/lib/store'
import { useT } from '@/lib/i18n'

export function WaiterOff() {
  const t = useT()
  const signOut = async () => {
    useStore.getState().clearTenantCache()
    await signOutThisDevice(createClient())
    window.location.href = '/login'
  }
  return (
    <div className="flex h-dvh w-full flex-col items-center justify-center gap-5 bg-background p-6 text-center">
      <div className="size-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
        <UserX className="size-7" />
      </div>
      <div className="max-w-sm flex flex-col gap-2">
        <h1 className="text-xl font-bold text-foreground">{t('waiter.off.title')}</h1>
        <p className="text-sm text-muted-foreground">{t('waiter.off.body')}</p>
      </div>
      <button type="button" onClick={signOut}
        className="tap h-12 px-6 rounded-xl border border-border bg-card text-sm font-semibold text-foreground">
        {t('waiter.off.signOut')}
      </button>
    </div>
  )
}
